import React from 'react'
import {
    Image
} from 'react-bootstrap'
import Notes from '../Notes'
import { Container } from 'react-bootstrap'
import v1 from '../../../Images/Skip_1.jpg'
import v2 from '../../../Images/Skip_2.jpg'
import v3 from '../../../Images/Skip_3.jpg'



function Skipping_stage_or_process() {
  return (
    <>
        {/* <Notes user={user} path={path} /> */}
        
        <Container fluid className='px-5 mt-4'>
            <h3><b>Skipping_stage_or_process</b></h3>
            <Image src={v1} thumbnail className='stepsImage'/>
            <Image src={v2} thumbnail className='stepsImage'/>
            <Image src={v3} thumbnail className='stepsImage'/>
            
            
            
            
        </Container>
    </>
  )
}

export default Skipping_stage_or_process